import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import Note from './Note';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LabelWithTooltip = ({
  labelText,
  tooltipText,
  noteText
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(HelpIcon, {
      title: tooltipText,
      children: labelText
    }), noteText && /*#__PURE__*/_jsx(Note, {
      text: noteText
    })]
  });
};
export default LabelWithTooltip;